import React from 'react'

interface Tab {
  key: string
  label: string
}

interface TabsProps {
  tabs: Tab[]
  activeTab: string
  onChange: (key: string) => void
  className?: string
}

export const Tabs: React.FC<TabsProps> = ({
  tabs,
  activeTab,
  onChange,
  className = '',
}) => {
  return (
    <>
      {/* Mobile: dropdown */}
      <select
        value={activeTab}
        onChange={(e) => onChange(e.target.value)}
        className="md:hidden w-full px-3 py-2 rounded border border-border bg-surface text-foreground text-sm mb-4"
      >
        {tabs.map((tab) => (
          <option key={tab.key} value={tab.key}>{tab.label}</option>
        ))}
      </select>

      {/* Desktop: horizontal tabs */}
      <div className={`hidden md:flex border-b border-border ${className}`}>
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => onChange(tab.key)}
            className={`
              px-4 py-2.5 text-sm font-medium transition-colors whitespace-nowrap
              border-b-2 -mb-px
              ${activeTab === tab.key
                ? 'border-primary text-primary'
                : 'border-transparent text-foreground-muted hover:text-foreground hover:border-border'
              }
            `}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </>
  )
}
